import React from "react"
import PropTypes from "prop-types"

//i18n
import { withTranslation } from "react-i18next"

import { PageContent, CustomBreadcrumb } from "components/Common"
import Profiles from "./Individuals"
import { ModuleIds } from "constant"

const RESOURCE = ModuleIds.Individual

const IndividualsContainer = ({ t }) => {
  const titleTag = t(`Individual`)
  return (
    <PageContent title={titleTag}>
      {/* PageTitle */}
      <CustomBreadcrumb
        breadcrumbItem={t("Individual List")}
        resource={RESOURCE}
      />

      {/* Page Body */}
      <Profiles />
    </PageContent>
  )
}

IndividualsContainer.propTypes = {
  t: PropTypes.any,
}

export default withTranslation(["partyPage"])(IndividualsContainer)
